module.exports = __webpack_public_path__ + "img/D201609_4.8aa1cded.jpg";